/* eslint-disable */
export default {
  requestError: {
    title: 'Infelizmente estamos com problemas de conexão, tente novamente mais tarde.'
  }
}

export const SIDEBAR = {
  PROFILE: 'Perfil',
  SECURITY: 'Segurança',
  EASYTOKEN: 'EasyToken',
  PERSONAL_INFO: 'Informações pessoais',
  RESIDENCIAL_ADDRESS: 'Endereço residencial',
  BUSINESS_INFO: 'Dados profissionais',
  SUITABILITY: 'Perfil de investidor',
  BANK_INFO: 'Contas cadastradas',
  FINANCIAL_SITUATION: 'Situação financeira',
  PASSWORD: 'Senha',
  FINANCE: 'Finanças',
  BROKER_TRANSFER: 'Transferência de corretora',
  CUSTODY_TRANSFER: 'Transferência de custódia',
  EDUCATIONAL: 'Aprenda a investir',
  HELP: 'Ajuda',
  LOGOUT: 'Sair',
  FINANCIAL_TRANSFER: 'Movimentação financeira',
  TRANSFER_SECURITY: 'Movimentação de ativos',
  TRANSACTION_HISTORY: 'Resumo de negociação',
  ACCOUNT_STATEMENT: 'Extrato',
  INCOME_REPORT: 'Informe de rendimentos',
  IRRF: 'Imposto retido na fonte',
  INVOICES: 'Notas de negociação',
  ELECTRONIC_SIGNATURE: 'Assinatura eletrônica',
  DEPOSITS_AND_WITHDRAWALS: 'Depósitos e retiradas',
  EXECUTE_OPERATION: 'Transferências',
  OPERATIONS: 'Movimentações',
  REPORTS: 'Relatórios',
  NOTIFICATIONS: 'Notificações',
  EARNINGS: 'Proventos'
}

export const MENUBAR = {
  STALKER: 'Acompanhar',
  INVEST: 'Investir',
  SETTING: 'Mais'
}

export const CUSTODY_MESSAGES = {
  DEFAULT_ERROR:
    'Oooops! Ocorreu um problema ao carregar os valores da sua carteira. Por favor, tente mais tarde.'
}

export const PAGE_NOT_FOUND = 'Página não encontrada'

export const FORM = {
  SAVE_CHANGES: 'Salvar alterações',
  CANCEL: 'Cancelar'
}

export const PAGE_PERSONAL_INFO = {
  Residential: 'Residencial',
  Commercial: 'Comercial',
  Cellphone: 'Celular',
  LABEL_NICKNAME: 'Apelido',
  LABEL_EMAIL: 'E-mail',
  LABEL_COUNTRY_CODE: 'País',
  LABEL_AREA_CODE: 'DDD',
  PAGE_CONFIRMATION: {
    TITLE: 'Solicitação em análise',
    MESSAGE: 'Suas alterações de dados pessoais estão em análise.'
  },
  AVATAR: {
    INVALID_FILE_TYPE: `O arquivo selecionado não é suportado.
  Os formatos válidos são jpg, jpeg, png, gif.`,
    INVALID_FILE_SIZE: 'Seu arquivo excedeu 3 MB. Selecione um arquivo inferior ao limite.',
    TITLE: 'Sua foto foi alterada com sucesso',
    MESSAGE: ''
  }
}

export const PAGE_NEW_PASSWORD = {
  PAGE_TITLE: 'Senha',
  PAGE_SUBTITLE:
    'Esta é a senha utilizada para fazer o login nos nossos sistemas. Recomendamos que troque regularmente para manter a segurança da sua conta.',
  POLICY_TITLE: 'Sua nova senha deve ter:',
  WARNING: 'Evite senhas utilizadas em outros sites, ou que sejam fáceis de descobrir',
  POLICY_1: `6 ou mais caracteres`,
  POLICY_2: 'um caracter especial (@*!%;:.)',
  POLICY_3: 'uma letra maiúscula',
  POLICY_4: 'uma letra minúscula',
  POLICY_5: 'um número',
  POLICY_6: 'números não sequenciais',
  POLICY_7: 'Evite senhas utilizadas em outros sites, ou que sejam fáceis de descobrir',
  LABEL_NEW_PASSWORD: 'Nova senha',
  LABEL_CONFIRM_NEW_PASSWORD: 'Confirmação de nova senha',
  PAGE_CONFIRMATION: {
    TITLE: 'Senha alterada com sucesso',
    SUBTITLE: ''
  }
}

export const PAGE_ADDRESS_INFO = {
  LABEL_SITUATION: 'Lista de situações ou profissões',
  LABEL_OCCUPATION: 'Lista de profissões',
  LABEL_ORGANIZATION: 'Nome da empresa',
  LABEL_CEP: 'CEP',
  LABEL_ACTIVITY_AREA: 'Selecione área de atuação',
  LABEL_ADDRESS: 'Endereço',
  LABEL_NUMBER: 'Número',
  LABEL_ADDITIONAL_INFORMATION: 'Complemento',
  LABEL_DISTRICT: 'Bairro',
  LABEL_CITY: 'Cidade',
  LABEL_STATE: 'Estado',
  LABEL_COUNTRY: 'País',
  LABEL_PHONE_COMMERCIAL: 'Telefone comercial',
  LABEL_PHONE: 'Comercial',
  LABEL_ADDRESS_FILE: 'Comprovante',
  LABEL_CNPJ_NUMBER: 'CNPJ da empresa',
  NO_FILE_MESSAGE: `Atenção: Para continuar com a alteração do endereço,
     o envio do comprovante de residência é obrigatório.`,
  LABEL_INVALID_CEP: 'CEP inválido',
  PAGE_CONFIRMATION: {
    TITLE: 'Solicitação em análise',
    SUBTITLE: 'Suas alterações de endereço residencial estão em análise.'
  },
  PAGE_TITLE: 'Endereço residencial',
  PAGE_SUBTITLE:
    'Para atualizar os dados de endereço, é necessário o envio de um comprovante de residência e uma análise de nossa equipe.'
}

export const BUSINESS_INFO = {
  PAGE_CONFIRMATION: {
    TITLE: 'Solicitação em análise',
    MESSAGE: 'Suas alterações de dados profissionais estão em análise.'
  },
  PAGE_TITLE: 'Dados profissionais',
  PAGE_SUBTITLE:
    'Lembre-se de atualizar os dados sempre que houver alterações na sua situação profissional.'
}
export const INVESTOR_PROFILE_SUITABILITY = {
  UNDEFINED: {
    TITLE: 'Descubra seu perfil de investidor',
    DESCRIPTION: `Para você investir e oferecermos produtos de investimentos adequados ao seu perfil, é necessário responder algumas perguntas.
    <br/><br/>
    O questionário é rápido e, ao final, você já pode começar a se aventurar.`,
    MODAL_LINK_TEXT: 'Entenda mais sobre perfis'
  },
  CONSERVATIVE: {
    TITLE: 'Você acredita que devagar se chega longe',
    DESCRIPTION: `Para você, não é um problema ter um investimento com menos rentabilidade, desde que ele seja mais seguro.`,
    MODAL_LINK_TEXT: 'Quando refazer o teste'
  },
  MODERATE: {
    TITLE: 'Você acredita que equilíbrio é tudo',
    DESCRIPTION: `Você pode até topar alguns riscos para agarrar a chance de ter mais rentabilidade, desde que esses riscos sejam controlados.`,
    MODAL_LINK_TEXT: 'Quando refazer o teste'
  },
  AGGRESSIVE: {
    TITLE: 'Você tem nervos de aço',
    DESCRIPTION: `Você topa mais riscos em troca da chance de ter uma rentabilidade maior, mesmo que isso signifique menos previsibilidade nos resultados.`,
    MODAL_LINK_TEXT: 'Quando refazer o teste'
  }
}

export const PAGE_BROKER_TRANSFER = {
  TITLE: 'Transferência de custódia entre corretoras',
  DESCRIPTION: `Você poderá transferir a custódia de ativos entre suas contas na
  NuInvest e de/para outras corretoras. Leia as instruções e regras antes de
  realizar qualquer transferência.`,
  TO_EASY: {
    TITLE: 'De outra corretora para NuInvest',
    DESCRIPTION: `Veja como é fácil transferir de outra corretora para a NuInvest:`,
    FIRST_ITEM: {
      index: '1',
      content: {
        info: `Informe-se sobre o procedimento adotado pela instituição, pois as transferências sempre devem ser realizadas pela corretora de origem.`
      }
    },
    SECOND_ITEM: {
      index: '2',
      content: {
        info: `Preencha o formulário fornecido pela corretora de origem, utilizando as informações abaixo:`,
        brokerCode: 'Código na NuInvest:',
        brokerName: 'Nome da Corretora: Easynvest - Título Corretora de Valores',
        brokerNumber: 'Número da Corretora: 090-6'
      }
    },
    THIRD_ITEM: {
      index: '3',
      content: {
        info: `Verifique a forma de envio e se existe a necessidade de reconhecer firma. Assine e envie o formulário para a corretora.`
      }
    }
  },
  FROM_EASY: {
    TITLE: 'Da NuInvest para outra corretora',
    DESCRIPTION: `Essas são as informações de transferência da NuInvest para outra
    corretora:`,
    FIRST_ITEM: {
      index: '1',
      content: {
        info: `Faça o download da Solicitação de Transferência de Valores Mobiliários, disponível
        no link:`,
        links: [
          {
            href:
              'https://s3-sa-east-1.amazonaws.com/br.com.easynvest.publicfiles/TransfCustodioFundos.docx',
            text: 'Solicitação para transferência de fundos de investimentos'
          },
          {
            href:
              'https://s3-sa-east-1.amazonaws.com/br.com.easynvest.publicfiles/TransfCustodia.doc',
            text: 'Solicitação de transferência para demais produtos de investimentos'
          }
        ]
      }
    },
    SECOND_ITEM: {
      index: '2',
      content: {
        info: `Preencha a Identificação do Cedente (Dados na NuInvest), a identificação do
        Cessionário (Dados na corretora de destino), os ativos que deseja transferir
        e assine no local indicado.`
      }
    },
    THIRD_ITEM: {
      index: '3',
      content: {
        info: `Envie a solicitação de transferência, digitalizada,
        assinada e cópia do seu documento com a mesma assinatura para:`,
        email: 'stvm@nuinvest.com.br',
        href: 'mailto:stvm@nuinvest.com.br'
      }
    }
  }
}

export const REQUEST_ERROR = {
  SERVER_ERROR: {
    TITLE: 'Infelizmente estamos com problemas de conexão, tente novamente mais tarde.'
  }
}

export const TRANSFER_SECURITY = {
  AUTHSTEPS: {
    TITLE: 'Transferência feita com sucesso',
    MESSAGE: 'Show! Em breve seu dinheiro estará disponível em sua conta.'
  },
  TITLE: 'Movimentação de Ativos',
  //eslint-disable-next-line
  SUBTITLE: `Você poderá transferir a custódia de ativos entre suas contas na NuInvest e de/para outras corretoras.
  Leia as instruções e regras antes de realizar qualquer transferência.`,
  ALERT: `Atenção: Informamos que a Conta Margem será desativada!
  A partir do dia 28/09/2021 os limites da Conta Margem não estarão mais disponíveis e não será mais possível manter os saldos financiados.`,
  LINK: 'Informações sobre a movimentação de ativos',
  ERROR_SERVER: `Ops! Estamos com um problema de comunicação com os nossos servidores.
    'Por favor, tente mais tarde!`,
  MODALS: {
    CONTRACT: {
      TITLE: 'Termo de adesão ',
      SUBTITLE: 'Faça o download e leia atentamente o termo de adesão.',
      BUTTON_TERM: 'Download do termo',
      READ_AND_AGREE: 'Li e concordo com o termo de adesão',
      SUBTITLE_SECONDLINE: 'Você precisa aceitá-lo para continuar.',
      BUTTON: 'Ok, entendi '
    },
    INFO: {
      TITLE: 'Informações sobre Movimentações ',
      TEXT: [
        `Se solicitar a movimentação de ativos até as 16:00, as ações estarão disponíveis para
        negociação na outra modalidade de conta no dia útil seguinte.`,
        `Até a efetivação da movimentação, os ativos que solicitou transferência ficarão
        bloqueados para negociação pela plataforma.`,
        `Para que a movimentação seja feita, as ações deverão estar liquidadas (D+3 da compra) e
        não poderá possuir ordens de venda do ativo. Caso contrário, toda solicitação será
        cancelada.`
      ],
      BUTTON: 'Ok, entendi ',
      MARGIN_ACCOUNT: {
        TITLE: 'Conta Margem ',
        TEXT: [
          `A conta margem é uma modalidade de conta onde sua carteira de ações serve de
        garantia para gerar limite de crédito para compra de algumas ações.`,
          'Os custos pela utilização do limite da Conta Margem são: ',
          [
            '- IOF - 0,0082% ao dia (dias corridos)',
            '- taxa de juros de 2,99% ao mês (dias úteis)',
            '- IOF adicional de 0,38% sobre cada novo financiamento.'
          ],
          `Os juros e IOF serão cobrados no primeiro dia útil do mês seguinte à utilização ou sempre
          que ocorrer amortização do saldo negativo.`,
          'Lembrando que a cobrança é feita sempre em sua Conta Depósito.'
        ]
      },
      RENT_ACCOUNT: {
        TITLE: 'Conta Aluguel ',
        TEXT: [
          `Operação muito utilizada por investidores que acreditam na desvalorização de uma
          determinada ação, o aluguel de ações permite ao investidor, que deseja vender uma ação que
          não tem em custódia, alugar as ações no mercado.`,
          `Após a adesão, deverá entrar em contato conosco (chat ou telefone) para tomar alugado o
          ativo e após isso já poderá efetuar a venda deste diretamente pela Conta Aluguel. Assim
          que a venda for concluída, poderá efetuar a compra do outro ativo desejado, também através
          da sua Conta Aluguel.`,
          `No ato do aluguel será cobrada a taxa de 0,5% sobre o valor total do aluguel, limitado a
          cobrança mínima de R$ 50,00 (cinquenta reais). A corretagem para compra ou venda das ações
          alugadas é de apenas R$ 10,00 (dez reais) por ordem executada através da Plataforma. Após
          a liquidação do aluguel, serão cobradas, taxa de liquidação da CBLC de 0,25%a.a, limitado
          a cobrança mínima de R$10,00 (dez reais) e a remuneração do doador, de acordo com a taxa
          negociada no momento do aluguel.`
        ]
      }
    }
  },
  SECURITY_TABLE: {
    NAME_COLUMNS: {
      ACTIVE: 'Ativo',
      ORIGIN: 'Origem',
      DESTINATION: 'Destino',
      QUANTITY: 'Quantidade'
    },
    ACCOUNT_TYPE: 'TD'
  },
  FORM: {
    ORIGIN_PLACEHOLDER_SELECT: 'Selecione a origem',
    DESTINATION_PLACEHOLDER_SELECT: 'Selecione o destino',
    SECURITY_PLACEHOLDER_SELECT: 'Selecione um ativo',
    CHECKBOX_CONTRACT: value => `Marcando essa opção, você concorda em habilitar
    a sua ${value}.
    Por favor, leia atentamente o termo para mais instruções e informações
    de cobrança de uso da ${value}.`,
    INFOLINK_TERMO_ADESAO: type => (type ? `Termo de Adesão ${type}` : 'Termo de Adesão'),
    ACCOUNT_NAME: 'rentAccount',
    ADD_SECURITY_BUTTON: 'Adicionar ativo',
    CONTINUE_BUTTON: 'Continuar',
    DISCLAIMER: `Só são aceitos quantidades inteiras de títulos do
    Tesouro Direto por restrições da bolsa`
  },
  ERROR_MESSAGE: {
    UNITY_ZERO: 'Não há mais quantidades disponíveis desse ativo',
    UNITY: value => `A quantidade de unidades não pode ser maior que ${value}`,
    VALUE: value => `O valor não pode ser superior ao seu saldo de ${value}`,
    STOCK_TO_TD: 'Não é possível enviar ações para o Tesouro Direto'
  }
}

export const EDUCATIONAL_MANUAL = {
  FRAME_TITLE: 'Lopes Filho - Onde Investir',
  LOPES_FILHO_ADDRESS: 'https://ondeinvestir.lopesfilho.com.br/noticias/'
}

export const TRANSACTION_HISTORY = {
  PAGE_TITLE: 'Resumo de Negociação',
  PAGE_SUBTITLE: `Encontre as informações de operações de renda variável feitas aqui na NuInvest`,
  SEARCH_BUTTON: 'Buscar',
  ORIGIN_PLACEHOLDER: 'Selecione a conta',
  SECURITY_PLACEHOLDER: 'Selecione um ativo',
  START_DATEPICKER_LABEL: 'Data inicial',
  END_DATEPICKER_LABEL: 'Data final',
  END_DATEPICKER_MESSAGE: 'Período de seleção deve ser de até 90 dias após a data inicial',
  NO_RESULT_ERROR: 'Ops! Não há resultados de extrato para mostrar no período selecionado'
}

export const ACCOUNT_STATEMENT = {
  PAGE_TITLE: 'Extrato',
  PAGE_SUBTITLE: `Acompanhe todas as transações e movimentações que
   ocorreram na sua conta em um só lugar`,
  BUTTON_LABEL: 'Buscar',
  SELECT_PLACEHOLDER: 'Selecione uma conta',
  START_DATE: 'Data Inicial',
  END_DATE: 'Data Final',
  DATE_PICKER_MESSAGE: 'Período de seleção deve ser de até 90 dias após a data inicial',
  BALANCE_TITLE_INITIAL: 'Saldo Inicial',
  BALANCE_TITLE_FINAL: 'Saldo Final',
  NO_RESULTS_ERROR: 'Ops! Não há resultados de extrato para mostrar no período selecionado.'
}

export const IRRF = {
  PAGE_TITLE: 'Imposto de Renda Retido na Fonte',
  PAGE_SUBTITLE: `Acompanhe os recolhimentos de imposto de renda para operações na
    bolsa que ocorreram na sua conta.`,
  BUTTON_LABEL: 'Buscar',
  SELECT_ORIGIN_PLACEHOLDER: 'Conta Origem',
  SELECT_TRANSACTION_PLACEHOLDER: 'Tipo de Operação',
  START_DATE: 'Data Inicial',
  END_DATE: 'Data Final',
  DATE_PICKER_MESSAGE: 'Período de seleção deve ser de até 90 dias após a data inicial',
  NO_RESULTS_ERROR: 'Ops! Não há resultados de extrato para mostrar no período selecionado.',
  TRANSACTION: [
    {
      key: 0,
      value: 'Day Trade'
    },
    {
      key: 1,
      value: 'Operações Comuns'
    }
  ]
}

export const INCOME_REPORT = {
  TITLE: 'Informe de Rendimentos',
  SUBTITLE: 'Selecione o ano abaixo para gerar o informe de rendimentos.',
  SELECT_PLACEHOLDER: 'Selecione o ano base',
  DOWNLOAD_BUTTON: 'Gerar',
  ERROR_TEXT: 'Desculpe, não foi possível carregar as informações.'
}

export const EARNINGS = {
  CATEGORY: {
    ALL: 'Carteira',
    STOKS: 'Ações',
    BDR: 'BDRs',
    FII: 'FIIs'
  }
}

export const PAGE_ELECTRONIC_SIGNATURE = {
  POLICY_LENGTH_CHARACTERS: PAGE_NEW_PASSWORD.POLICY_1,
  POLICY_SPECIAL_CHARACTER: PAGE_NEW_PASSWORD.POLICY_2,
  POLICY_AT_LEAST_CAPITALIZED_WORD: PAGE_NEW_PASSWORD.POLICY_3,
  POLICY_AT_LEAST_UNCAPITALIZED_WORD: PAGE_NEW_PASSWORD.POLICY_4,
  POLICY_AT_LEAST_ONE_NUMBER: PAGE_NEW_PASSWORD.POLICY_5,
  POLICY_NON_SEQUENCIAL_NUMBERS: PAGE_NEW_PASSWORD.POLICY_6,
  TITLE_NEW_ELECTRONIC_SIGNATURE: 'Sua nova assinatura eletrônica deve ter:',
  LABEL_WARNING_NEW_ELECTRONIC_SIGNATURE:
    'Evite senhas que contenham seu nome, data de aniversário ou que já tenham sido utilizadas.',
  NEW_ELECTRONIC_SIGNATURE: 'Crie sua nova assinatura eletrônica',
  LABEL_NEW_ELECTRONIC_SIGNATURE: 'Nova assinatura eletrônica',
  LABEL_CONFIRM_NEW_ELECTRONIC_SIGNATURE: 'Confirmar assinatura eletrônica',
  PASSWORD_DOESNT_MATCH: 'Ops! A confirmação deve ser igual à nova assinatura eletrônica.',
  ELECTRONIC_SIGNATURE_AUTH_SUCCESS_TITLE: 'Assinatura eletrônica alterada com sucesso!',
  ELECTRONIC_SIGNATURE_AUTH_SUCCESS_MESSAGE: `Suas operações serão validadas com sua nova
  assinatura.`,
  ELECTRONIC_SIGNATURE_CHANGE_CONFIRMATION: 'Insira sua assinatura atual para validar a mudança',
  LABEL_FORGOT_SUCCESS_TITLE: 'Nova assinatura eletrônica enviada',
  LABEL_FORGOT_SUCCESS_MESSAGE: `Um email com link para recuperação
  de nova assinatura eletrônica foi enviado para seu e-mail! Caso não veja em sua
    caixa de entrada tente localiza-la em seu lixo eletrônico`,
  LABEL_FORGOT_SUBTITLE:
    'Não se preocupe. Um email com link será enviado automaticamente para seu e-mail cadastrado:'
}

export const BANKACCOUNT = {
  main_account: 'Esta é sua conta principal',
  main_account_alert: 'Para excluir esta conta, é preciso definir uma outra conta como principal.',
  delete_success_title: 'Conta excluída',
  delete_success_message: 'Sua conta bancária foi excluída com sucesso!',
  add_success_title: 'Nova conta cadastrada',
  add_success_message: 'Sua nova conta bancária foi incluída com sucesso!',
  edit_success_title: 'Solicitação feita com sucesso',
  edit_success_message: 'Sua solicitação está em análise e logo será efetuada!',
  info_message: `A conta deve ser da mesma titularidade e CPF cadastrados na NuInvest.
    Caso contrário, as retiradas não serão executadas.`,
  PAGE_TITLE: 'Conta bancária',
  PAGE_SUBTITLE:
    'Gerencie suas contas bancárias para facilitar o recebimento e envio de recursos na NuInvest.',
  TOOLTIP: {
    MESSAGE: 'Preencha a agência com 4 números, sem o dígito',
    BUTTON_TEXT: 'Ok, entendi!'
  },
  show_all_banks_button: 'Ver lista completa'
}

export const INVOICES = {
  PAGE_TITLE: 'Notas de Negociação',
  PAGE_SUBTITLE: `Encontre as notas de negociação das
  operações de um título ou ativo transacionado aqui na NuInvest`,
  SEARCH_BUTTON: 'Buscar',
  ORIGIN_PLACEHOLDER: 'Selecione a conta',
  SECURITY_PLACEHOLDER: 'Selecione o ativo',
  START_DATEPICKER_LABEL: 'Data inicial',
  END_DATEPICKER_LABEL: 'Data final',
  END_DATEPICKER_MESSAGE: 'Período de seleção deve ser de até 90 dias após a data inicial',
  NO_RESULT_ERROR: 'Ops! Não há resultados para mostrar no período selecionado'
}

export const SFP = {
  SUCCESS_TITLE: 'Solicitação feita com sucesso',
  SUCCESS_SUBTITLE: 'Sucesso! Sua solicitação está em análise'
}

export const NEW_PASSWORD = {
  TITLE: 'Senha alterada com sucesso',
  SUBTITLE: 'A partir de agora, para efeturar o login utilize a nova senha ;)'
}

export const WITHDRAWALS = {
  SUCCESS_TITLE: 'Solicitação de retirada feita com sucesso',
  SUCCESS_TEXT:
    'Sua solicitação de retirada está em análise e logo seu dinheiro será enviado para sua conta bancária!'
}

export const BANK_LIST = {
  TITLE: 'Clique na conta bancária para a qual deseja retirar seu dinheiro',
  BUTTON_TITLE: 'Contas Cadastradas',
  BRANCH: 'Agência',
  ACCOUNT: 'Conta Corrente'
}

export const WITHDRAWAL_VALUE = {
  WITHDRAWAL_VALUE_INVALID:
    'Ops! Você não pode retirar um valor maior do que o disponível na sua Conta NuInvest.',
  TITLE: 'Valor da retirada',
  BUTTON_TITLE: 'Continuar'
}

export const CHECK_WITHDRAWAL = {
  NOTICE: `
  Se a sua solicitação for enviada até as 14h,
  você conseguirá resgatar o dinheiro no mesmo dia.
  Após esse horário, o resgate será agendado para o dia útil seguinte.
  `,
  BUTTON_TITLE: 'Continuar',
  BRANCH: 'Agência',
  ACCOUNT: 'Conta Corrente'
}

export const PAGE_CUSTODY_TRANSFER = {
  TITLE: 'Transferência de custódia',
  TO_EASY: {
    LINK: '/movimentacoes/transferencia-de-custodia/portabilidade-entrada',
    TITLE: 'Trazer para NuInvest',
    SUBTITLE: 'Como fazer a transferência dos seus investimentos para a NuInvest'
  },
  FROM_EASY: {
    LINK: '/movimentacoes/transferencia-de-custodia/portabilidade-saida',
    TITLE: 'Levar para outra corretora',
    SUBTITLE: 'Como transferir seus investimentos para outra corretora'
  },
  REQUEST: {
    TITLE: 'Acompanhar pedido',
    DATE: 'Data de envio',
    TYPE: 'Tipo do pedido',
    LINK: 'Ver status'
  },
  MODAL_REQUEST: {
    TITLE: 'Detalhe do pedido',
    DATE: 'Data de envio',
    TYPE: 'Tipo do pedido',
    TITLE_DOWNLOAD: 'Documentos para download:',
    TEXT_URL: 'Solicitação de transferência de valores mobiliários - STVM',
    TEXT_URL_FUNDS: 'Transferência das aplicações em Fundos de Investimento'
  },
  MODAL: {
    TITLE: 'Dicas importantes',
    BUTTON: 'Ok, entendi'
  }
}

export const PAGE_CUSTODY_TRANSFER_IN = {
  TITLE: 'Trazer de outra corretora para a NuInvest',
  SUBTITLE: 'Para solicitar a portabilidade dos seus ativos siga o passo a passo abaixo:',
  STEP_1: {
    title: 'Para transferência de Renda Fixa Privada',
    description: `É importante que você nos envie com pelo menos dois dia úteis de antecedência, as notas de negociação dos investimentos em Renda Fixa que você deseja transferir para a NuInvest, junto com a STVM preenchida para:`,
    link: 'stvm@nuinvest.com.br',
    href: 'mailto:stvm@nuinvest.com.br'
  },
  STEP_2: {
    description: `O pedido de transferência de custódia para a NuInvest deverá ser solicitado para a corretora onde você possui os investimentos.`
  },
  STEP_3: {
    description: `Preencha o formulário fornecido pela corretora de origem, utilizando as informações abaixo:`,
    info: {
      brokerCode: 'Código na NuInvest:',
      brokerName: 'Nome da Corretora: Easynvest - Título Corretora de Valores',
      brokerNumber: 'Número da Corretora: 090-6'
    }
  },
  STEP_4: {
    description: `Verifique a forma de envio e se existe a necessidade de reconhecer firma.
      Assine e envie o formulário para a corretora.`
  }
}

export const PAGE_CUSTODY_TRANSFER_OUT = {
  TITLE: 'Levar da NuInvest para Outra corretora',
  SUBTITLE: 'Para solicitar a portabilidade dos seus ativos siga o passo-a-passo abaixo:',
  STEP_1: {
    description: `Faça o download do documento de solicitação de transferência, disponível abaixo:`,
    link_1: {
      href:
        'https://s3-sa-east-1.amazonaws.com/br.com.easynvest.publicfiles/TransfCustodioFundos.docx',
      text: 'Transferência de Fundos de Investimentos',
    },
    link_2: {
      href:
        'https://s3-sa-east-1.amazonaws.com/br.com.easynvest.publicfiles/TransfCustodia.doc',
      text: 'Transferência para demais produtos de investimentos',
    }
  },
  STEP_2: {
    description: `Preencha a Identificação do Cedente (Dados na NuInvest), a identificação do
      Cessionário (Dados na corretora de destino), os ativos que deseja transferir e assine no local indicado.`
  },
  STEP_3: {
    description: `Envie o(s) documento(s) já preenchido para a nossa Central do Investidor `,
    bold: `via Chat.`,
    instructions: `Mais > Ajuda > Chat`
  },
  STEP_4: {
    description: `Para transferência de títulos de Renda Fixa é necessário enviar para a nova corretora todos
      as notas de negociação. Faça o download dos arquivos do menu relatórios.`
  }
}

export const HELP = {
  rules: {
    link: 'https://cdn.nubank.com.br/investments/regulamentacao/rpa/regras-parametros-atuacao.pdf'
  }
}
